import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

/**
 * Main Entry Point
 * 
 * IMPORTANT: This application does NOT use Service Workers or PWA functionality.
 * This is intentional to avoid conflicts when running in an iframe.
 * 
 * DO NOT add:
 * - Service Worker registration
 * - PWA manifest
 * - Workbox
 * - Any offline caching
 */

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
